var exports = {
  "Y9": "Header__P35xWs",
  "l9": "Trigger__jQxaSh",
  "nY": "AccordionItems__XTuoZr",
};

module.exports = exports;
